var _path, _circle, _path2, _circle2, _path3, _circle3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgGroupChecked = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 20,
    viewBox: "0 0 40 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 11.25C22.7167 11.25 25.1167 11.9 27.0667 12.75C28.8667 13.55 30 15.35 30 17.3V18.3333C30 19.25 29.25 20 28.3333 20H11.6667C10.75 20 10 19.25 10 18.3333V17.3167C10 15.35 11.1333 13.55 12.9333 12.7667C14.8833 11.9 17.2833 11.25 20 11.25ZM6.66667 11.6667C8.5 11.6667 10 10.1667 10 8.33333C10 6.5 8.5 5 6.66667 5C4.83333 5 3.33333 6.5 3.33333 8.33333C3.33333 10.1667 4.83333 11.6667 6.66667 11.6667ZM8.55 13.5C7.93333 13.4 7.31667 13.3333 6.66667 13.3333C5.01667 13.3333 3.45 13.6833 2.03333 14.3C0.8 14.8333 0 16.0333 0 17.3833V18.3333C0 19.25 0.75 20 1.66667 20H7.5V17.3167C7.5 15.9333 7.88333 14.6333 8.55 13.5ZM33.3333 11.6667C35.1667 11.6667 36.6667 10.1667 36.6667 8.33333C36.6667 6.5 35.1667 5 33.3333 5C31.5 5 30 6.5 30 8.33333C30 10.1667 31.5 11.6667 33.3333 11.6667ZM40 17.3833C40 16.0333 39.2 14.8333 37.9667 14.3C36.55 13.6833 34.9833 13.3333 33.3333 13.3333C32.6833 13.3333 32.0667 13.4 31.45 13.5C32.1167 14.6333 32.5 15.9333 32.5 17.3167V20H38.3333C39.25 20 40 19.25 40 18.3333V17.3833ZM20 0C22.7667 0 25 2.23333 25 5C25 7.76667 22.7667 10 20 10C17.2333 10 15 7.76667 15 5C15 2.23333 17.2333 0 20 0Z",
    fill: "#009966"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 5,
    r: 5,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 0C17.24 0 15 2.24 15 5C15 7.76 17.24 10 20 10C22.76 10 25 7.76 25 5C25 2.24 22.76 0 20 0ZM18.645 7.145L16.85 5.35C16.655 5.155 16.655 4.84 16.85 4.645C17.045 4.45 17.36 4.45 17.555 4.645L19 6.085L22.44 2.645C22.635 2.45 22.95 2.45 23.145 2.645C23.34 2.84 23.34 3.155 23.145 3.35L19.35 7.145C19.16 7.34 18.84 7.34 18.645 7.145Z",
    fill: "#009966"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 8,
    r: 4,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33 4C30.792 4 29 5.792 29 8C29 10.208 30.792 12 33 12C35.208 12 37 10.208 37 8C37 5.792 35.208 4 33 4ZM31.916 9.716L30.48 8.28C30.324 8.124 30.324 7.872 30.48 7.716C30.636 7.56 30.888 7.56 31.044 7.716L32.2 8.868L34.952 6.116C35.108 5.96 35.36 5.96 35.516 6.116C35.672 6.272 35.672 6.524 35.516 6.68L32.48 9.716C32.328 9.872 32.072 9.872 31.916 9.716Z",
    fill: "#009966"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 8,
    r: 4,
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 4C4.792 4 3 5.792 3 8C3 10.208 4.792 12 7 12C9.208 12 11 10.208 11 8C11 5.792 9.208 4 7 4ZM5.916 9.716L4.48 8.28C4.324 8.124 4.324 7.872 4.48 7.716C4.636 7.56 4.888 7.56 5.044 7.716L6.2 8.868L8.952 6.116C9.108 5.96 9.36 5.96 9.516 6.116C9.672 6.272 9.672 6.524 9.516 6.68L6.48 9.716C6.328 9.872 6.072 9.872 5.916 9.716Z",
    fill: "#009966"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGroupChecked, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/group_checked.fdc10f43.svg";
export { ForwardRef as ReactComponent };